<div class="message-template-creator-popover">
  <!-- ローディング表示 -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner></mat-spinner>
    <p>処理中...</p>
  </div>

  <!-- ポップオーバーヘッダー -->
  <div class="popover-header">
    <h2>{{ getDialogTitle() }}</h2>
  </div>

  <!-- ポップオーバー内容 -->
  <div class="popover-content">

    <!-- エラーメッセージ表示 -->
    <div *ngIf="errorMessages.length > 0" class="error-messages">
      <div *ngFor="let error of errorMessages" class="error-message">
        {{ error }}
      </div>
    </div>

    <!-- フォーム -->
    <form #templateForm="ngForm" class="template-form">

      <!-- テンプレート名 -->
      <div class="form-field">
        <label class="field-label">テンプレート名 <span class="required">*</span></label>
        <input
          type="text"
          name="name"
          maxlength="200"
          placeholder="テンプレート名を入力"
          [(ngModel)]="formData.name"
          [disabled]="isLoading"
          required
          autofocus
          class="form-input">
        <small class="field-hint">選択する時に表示する名称</small>
      </div>

      <!-- 件名 -->
      <div class="form-field">
        <label class="field-label">件名 <span class="required">*</span></label>
        <input
          type="text"
          name="subject"
          maxlength="200"
          placeholder="件名を入力"
          [(ngModel)]="formData.subject"
          [disabled]="isLoading"
          required
          class="form-input">
      </div>

      <!-- 本文 -->
      <div class="form-field">
        <label class="field-label">本文 <span class="required">*</span></label>
        <textarea
          name="content"
          rows="6"
          maxlength="4000"
          placeholder="置き換え文字を使用する場合は「%氏名%」のように入力してください。"
          [(ngModel)]="formData.content"
          [disabled]="isLoading"
          required
          class="form-textarea">
        </textarea>
        <div class="field-hint">
          【置き換え文字列】%氏名%<br>
          請求メッセージのみ：%価格% %決済URL%
        </div>
      </div>

      <!-- カテゴリ選択 -->
      <div class="form-field">
        <label class="field-label">カテゴリ</label>
        <div class="category-list" *ngIf="formData.mailTemplateCategory?.length > 0">
          <label *ngFor="let category of formData.mailTemplateCategory; let i = index" class="category-item">
            <input
              type="checkbox"
              [(ngModel)]="category.checked"
              [name]="'category_' + category.id"
              [disabled]="isLoading">
            <span>{{ category.name }}</span>
          </label>
        </div>
        <div *ngIf="!formData.mailTemplateCategory?.length" class="no-categories">
          カテゴリが見つかりません
        </div>
      </div>

    </form>
  </div>

  <!-- ポップオーバーアクション -->
  <div class="popover-actions">
	  <button
		  mat-flat-button
		  (click)="onCancel()"
		  [disabled]="isLoading">
		  キャンセル
	  </button>
	  <button
		  mat-flat-button
		  color="primary"
		  (click)="onSave()"
		  [disabled]="isLoading"
	  >
		  {{ getSaveButtonLabel() }}
	  </button>
  </div>
</div>
